import React from 'react';

import { Link } from 'react-router-dom';

import { MCCard } from 'components/mc';
import useTranslation from 'hooks/useTranslation';

import s from './SupportCard.module.scss';

const ChatGlyph = () => (
  <svg width="18" height="18" viewBox="0 0 18 18" fill="none" aria-hidden="true">
    <path
      d="M15.75 8.625c0 3.107-3.022 5.625-6.75 5.625-.813 0-1.592-.12-2.312-.34L3.375 15l.9-2.699C3.083 11.278 2.25 10.03 2.25 8.625 2.25 5.518 5.272 3 9 3s6.75 2.518 6.75 5.625Z"
      stroke="currentColor"
      strokeWidth="1.4"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
    <path d="M6.2 8.6h.01M9 8.6h.01M11.8 8.6h.01" stroke="currentColor" strokeWidth="1.8" strokeLinecap="round" />
  </svg>
);

// Dashboard entry point to the support section — a clear, labeled card (the audience
// skews older; a labeled button beats an unlabeled floating icon).
const SupportCard = () => {
  const t = useTranslation();

  return (
    <MCCard pad="md" className={s.card}>
      <h2 className={s.title}>
        <ChatGlyph />
        {t('dashboard_support_title')}
      </h2>
      <p className={s.text}>{t('dashboard_support_text')}</p>
      <Link to="/support" className={s.btn}>
        {t('dashboard_support_btn')}
      </Link>
    </MCCard>
  );
};

export default SupportCard;
